import React from 'react';
import { Flex, Button, useTheme } from '@aws-amplify/ui-react';

const ActionButtons = ({ buttons }) => {
    const { tokens } = useTheme();

    return (
        <Flex direction="column" gap={tokens.space.medium} marginTop={tokens.space.large}>
            {buttons.map((button, index) => {
                const { text, ...buttonProps } = button;
                return (
                    <Button
                        key={index}
                        size="default"
                        isFullWidth
                        {...buttonProps}
                    >
                        {text}
                    </Button>
                );
            })}
        </Flex>
    );
};

export default ActionButtons;
